import { defineComponent as y, mergeModels as i, useModel as c, useSlots as k, ref as V, createBlock as f, openBlock as u, withCtx as t, createCommentVNode as w, createSlots as z, renderSlot as r, normalizeProps as s, guardReactiveProps as d } from "vue";
import S from "./ScalarComboboxOptions.vue.js";
import B from "./ScalarComboboxPopover.vue.js";
const h = /* @__PURE__ */ y({
  __name: "ScalarComboboxMultiselect",
  props: /* @__PURE__ */ i({
    options: {},
    placeholder: {},
    placement: {},
    offset: { type: [Number, Object, Function] },
    resize: { type: Boolean },
    target: {},
    middleware: {},
    teleport: { type: [Boolean, String] }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ i(["add"], ["update:modelValue"]),
  setup(g, { expose: v, emit: $ }) {
    const n = c(g, "modelValue"), b = $;
    k();
    const p = V(null);
    return v({ comboboxPopoverRef: p }), (e, l) => (u(), f(B, {
      ref_key: "comboboxPopoverRef",
      ref: p,
      middleware: e.middleware,
      offset: e.offset,
      placement: e.placement ?? "bottom-start",
      resize: e.resize,
      target: e.target,
      teleport: e.teleport
    }, {
      default: t(({ open: a }) => [
        r(e.$slots, "default", { open: a })
      ]),
      popover: t(({ open: a }) => {
        var m;
        return [
          (m = e.options) != null && m.length ? (u(), f(S, {
            key: 0,
            modelValue: n.value,
            "onUpdate:modelValue": l[0] || (l[0] = (o) => n.value = o),
            multiselect: "",
            open: a,
            options: e.options,
            placeholder: e.placeholder,
            onAdd: l[1] || (l[1] = (o) => b("add"))
          }, z({ _: 2 }, [
            e.$slots.option ? {
              name: "option",
              fn: t((o) => [
                r(e.$slots, "option", s(d(o)))
              ]),
              key: "0"
            } : void 0,
            e.$slots.group ? {
              name: "group",
              fn: t((o) => [
                r(e.$slots, "group", s(d(o)))
              ]),
              key: "1"
            } : void 0,
            e.$slots.add ? {
              name: "add",
              fn: t((o) => [
                r(e.$slots, "add", s(d(o)))
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["modelValue", "open", "options", "placeholder"])) : w("", !0)
        ];
      }),
      _: 3
    }, 8, ["middleware", "offset", "placement", "resize", "target", "teleport"]));
  }
});
export {
  h as default
};
